/**
 * Takes down the loading screen that `index.html` paints before any JS runs.
 *
 * The splash exists because the app used to show nothing at all until the whole
 * bundle had arrived and the API had answered. It has to come down at the
 * moment there is something real behind it — not when React mounts, which is
 * earlier and would put the blank screen back for the length of the API call.
 *
 * Removed from the document rather than hidden. A fixed, full-screen element
 * left in place is one interrupted transition away from covering the app, and
 * nothing on the page would explain why.
 */
export function dismissSplash(): void {
  const splash = document.getElementById('splash');
  if (!splash) return;

  // Guard against being called twice while the fade is running — a second
  // call would restart the timer and, worse, schedule a second removal.
  if (splash.classList.contains('done')) return;
  splash.classList.add('done');

  const remove = () => splash.remove();
  /*
   * `transitionend` alone is not enough: it never fires for a viewer with
   * reduced motion, where the transition is switched off, and it does not fire
   * for a tab that is backgrounded mid-fade. The timeout is what guarantees the
   * splash actually goes.
   */
  splash.addEventListener('transitionend', remove, { once: true });
  window.setTimeout(remove, 400);
}
